import isNumber from './isNumber'

export default function isPositiveNumber(value?: string | number): boolean {
  return !!value && isNumber(value) && Number.isFinite(+value) && +value > 0
}
